export default "__VITE_ASSET__CzhIkmcg__"